/**
 * The current AgentMax notch mark: eleven discrete pixel cells with a hairline gutter.
 * This matches the marketing site and macOS product glyph.
 */
const CELLS: ReadonlyArray<readonly [number, number]> = [
  [12, 0], [36, 0], [60, 0],
  [0, 24], [0, 48], [0, 72],
  [72, 24], [72, 48], [72, 72],
  [24, 48], [48, 48],
];

const CELL = 20;
const INSET = 2;

export function PixelMark({ size = 30, className }: { size?: number; className?: string }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 96 96"
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      <g fill="var(--pixel-mark-color, #176bf2)">
        {CELLS.map(([x, y]) => (
          <rect key={`${x}-${y}`} x={x + INSET} y={y + INSET} width={CELL} height={CELL} rx="1" />
        ))}
      </g>
    </svg>
  );
}
